import Blueprint from '../components/Workstations/BlueprintWebview'

let routes = {
  path: '/blueprint',
  component: resolve => require(['../components/layout/Blank'], resolve),
  children: [
    {
      path: '/blueprint/:id?/:date?/:time_start?/:time_end?',
      name: 'Blueprint',
      component: Blueprint
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/blueprint.js